import COLORS from "../../theme/Colors";

export const variationsColors =
{
    info: COLORS.notificationComplete,
    success:COLORS.notificationSuccess,
    warning:COLORS.notificationWarning,
    danger:COLORS.notificationError,
}